import { StyledVideoModal } from './VideoModal.styled';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';

const VideoModal = () => {
  const {
    setShowVideo
  } = useContext(AppContext);
  return (
    <StyledVideoModal>
      <div className='video-background' onClick={(e) => e.stopPropagation()}>
        <div className='video-close' onClick={() => setShowVideo(false)}>
          <img src='/assets/equip.svg'/>
        </div>
        <div className='video-container'>
          <div style={{padding: '41.89% 0 0 0', position: 'relative'}}>
            <iframe src="https://player.vimeo.com/video/1027819383?h=a38a12020b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="BASEJUMP - ACTION FIGURES"></iframe>
          </div><script src="https://player.vimeo.com/api/player.js"></script>
        </div>
      </div>
    </StyledVideoModal>
  );
};

export default VideoModal;
